module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/helper-text/helper-text.component.scss
// module id = ./src/app/modules/common-module/components/helper-text/helper-text.component.scss
// module chunks = 9